(() => {
  // Server content and native pagination remain usable without JavaScript.
  // Controls are rendered only for a single, complete server page (<=250).
  const initialize = scope => {
    for (const host of scope.querySelectorAll('[data-bhp-native-catalog]')) {
      if (host.dataset.bhpInitialized) continue;
      const controls = host.querySelector('[data-bhp-filter-controls]');
      if (!controls) continue;
      host.dataset.bhpInitialized = 'true';
      const search = host.querySelector('[data-bhp-model-search]');
      const filter = host.querySelector('[data-bhp-series-filter]');
      const cards = [...host.querySelectorAll('[data-bhp-model]')];
      const series = [...new Set(cards.map(card => card.dataset.bhpSeries).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'nb'));
      if (series.length > 1) {
        for (const name of series) filter.add(new Option(name, name));
        host.querySelector('[data-bhp-series-label]').hidden = false;
      }
      const update = () => {
        const query = search.value.trim().toLocaleLowerCase('nb');
        let count = 0;
        for (const card of cards) {
          card.hidden = !card.dataset.bhpModel.toLocaleLowerCase('nb').includes(query) || Boolean(filter.value && card.dataset.bhpSeries !== filter.value);
          if (!card.hidden) count++;
        }
        host.querySelector('[data-bhp-result-count]').textContent = `${count} ${count === 1 ? 'produkt' : 'produkter'}`;
        host.querySelector('[data-bhp-no-results]').hidden = count !== 0;
      };
      search.addEventListener('input', update);
      filter.addEventListener('change', update);
      host.querySelector('[data-bhp-reset]').addEventListener('click', () => {
        search.value = '';
        filter.value = '';
        update();
        search.focus();
      });
      controls.hidden = false;
      update();
    }
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
